import { industries } from "../../data/mock";
import { useScrollReveal } from "../../hooks/useScrollReveal";

export const IndustriesSection = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="industries" ref={ref} className="py-24 bg-white">
      <div className={`max-w-7xl mx-auto px-6 lg:px-8 transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}>
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-[#C8A951] text-sm font-semibold tracking-[0.15em] uppercase mb-4 block">
            Our Verticals
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0F172A] leading-tight mb-4 tracking-tight">
            8 Industries.
            <br />
            Infinite Possibilities.
          </h2>
          <p className="text-lg text-[#64748B] leading-relaxed">
            We curate premium conferences across the sectors shaping our world — connecting
            the leaders who are driving real change.
          </p>
        </div>

        {/* Industry Grid — display only, not clickable */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {industries.map((industry, i) => {
            const IconComponent = industry.icon;
            return (
              <div
                key={industry.id}
                className="bg-[#FAFAF8] rounded-2xl p-6 border border-[#E2E8F0]"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-[#0F172A] flex items-center justify-center mb-5">
                  <IconComponent className="w-6 h-6 text-[#C8A951]" />
                </div>

                {/* Content */}
                <h3 className="text-lg font-bold text-[#0F172A] mb-2">
                  {industry.name}
                </h3>

                <p className="text-sm text-[#64748B] leading-relaxed">
                  {industry.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
